<i class="{{className}} services-select__icon {{inverted ? 'services-select__icon--inverse': ''}}"
   aria-hidden="true"></i>